import type { LearningLessonDetail } from '@services/firebase/learning'

export type OnlineBookTemplate =
  | 'blog'
  | 'conversation'
  | 'heading'
  | 'highlighter'
  | 'horizontal_rule'
  | 'image'
  | 'lists'
  | 'multiple_choice'
  | 'pronouncing_practice'
  | 'structure'
  | 'subtitle'
  | 'vocabulary'
  | 'vocabularyWithImage'
  | 'vocabularyWithoutImage'
  | string

// Legacy content exists with camelCase, snake_case, dash, and spaced template IDs.
export function resolveOnlineBookTemplate(
  block: Pick<LearningLessonDetail, 'template'>,
): OnlineBookTemplate {
  const template = (block.template ?? 'heading').trim()

  if (!template) {
    return 'heading'
  }

  const normalizedTemplate = template
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toLowerCase()

  switch (normalizedTemplate) {
    case 'multiplechoice':
    case 'multiple_choice':
      return 'multiple_choice'
    case 'horizontalrule':
    case 'horizontal_rule':
      return 'horizontal_rule'
    case 'pronouncingpractice':
    case 'pronouncing_practice':
      return 'pronouncing_practice'
    case 'vocabularywithimage':
    case 'vocabulary_with_image':
      return 'vocabularyWithImage'
    case 'vocabularywithoutimage':
    case 'vocabulary_without_image':
      return 'vocabularyWithoutImage'
    default:
      return normalizedTemplate
  }
}

const legacyOnlineBookTemplateIds = new Set<OnlineBookTemplate>([
  'blog',
  'conversation',
  'heading',
  'highlighter',
  'horizontal_rule',
  'image',
  'lists',
  'pronouncing_practice',
  'structure',
  'subtitle',
  'vocabulary',
  'vocabularyWithImage',
  'vocabularyWithoutImage',
])

// ListOfOnlineBooks renders published blocks in Firestore order and falls back to Heading.
export function resolveLegacyOnlineBookRendererTemplate(
  block: Pick<LearningLessonDetail, 'template'>,
): OnlineBookTemplate {
  const template = resolveOnlineBookTemplate(block)

  return legacyOnlineBookTemplateIds.has(template) ? template : 'heading'
}

export function getOnlineBookBlocksInSourceOrder(
  blocks: readonly LearningLessonDetail[],
) {
  return [...blocks]
}
